module.exports = __webpack_public_path__ + "img/ukgeneral.292005bd.png";